import React from 'react';

const ThermaeIcon = (props) => {
  return (
    <img
      alt="Termy"
      src="/static/images/icons/tourist_attractions/thermae.svg"
      {...props}
    />
  );
};

export default ThermaeIcon;
